<template>
  <b-modal
    id="bv-modal-trash-delete-object"
    size="lg"
    :ok-disabled="deleteCheck != 'DELETE'"
    centered
    @ok="deleteObject"
    @show="resetCheck"
  >
    <template v-slot:modal-title>
      Delete permanently
    </template>
    Are you sure you want to delete the {{ object.name }} {{ typeLabel }}? You won't be able to revert this action
    <p>Type <strong>DELETE</strong> to delete the {{ typeLabel }}</p>
    <input type="text" class="form-control" v-model="deleteCheck">
  </b-modal>
</template>

<script>
import {
  MONITOR_TRASH_DELETE
} from "@/store/actions.type";

export default {
  name: 'MonitorTrashDelete',
  props: ['object', 'type', 'typeLabel'],
  data() {
    return {
      deleteCheck: ''
    }
  },
  methods: {
    resetCheck() {
      this.deleteCheck = '';
    },
    deleteObject() {
      let payload = {
        type: this.type,
        objectId: this.object.id
      }
      this.$store.dispatch(MONITOR_TRASH_DELETE, payload).then(() => {
        this.$bvToast.toast(`${this.typeLabel} ${this.object.name} has been deleted successfully`, {
          title: `${this.typeLabel} deleted`,
          toaster: 'b-toaster-bottom-right',
          autoHideDelay: 4000,
          variant: 'primary'
        });
        this.$emit('objectDeleted');
        this.deleteCheck = '';
      });
    }
  }
}
</script>